import chat_profile from "../../../assets/images/chat_profile.png";
import MessageContent from "./MessageContent";

const isSameDay = (a, b) => {
  const d1 = new Date(a);
  const d2 = new Date(b);
  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  );
};

const MessagesPanel = ({
  t,
  lang,
  conversation,
  messages,
  loading,
  loadingOlder,
  error,
  containerRef,
  onScroll,
}) => {
  if (!conversation) {
    return (
      <div className="my-card my-chat-card-body d-flex align-items-center justify-content-center text-muted">
        {t("selectAConversationToViewMessages")}
      </div>
    );
  }

  return (
    <div className="my-card my-chat-card-body">
      <div className="chat-message">
        <div className="chat-message-header">
          <div className="chat-message-avatar">
            <img src={chat_profile} alt="profile" />
          </div>
          <div className="chat-message-user-info-icons">
            <div className="chat-message-user-info">
              <strong>
                {conversation.customerName || t("Customer")}
                <i className="fas fa-arrow-right-arrow-left mx-2 text-muted small"></i>
                {conversation.providerName || t("provider")}
              </strong>
            </div>
            <span className="text-muted small fst-italic">{t("readOnlyViewer")}</span>
          </div>
        </div>

        <div
          className="chat-message-body"
          key={conversation.conversationId}
          ref={containerRef}
          onScroll={onScroll}
        >
          {loadingOlder && (
            <div className="text-center py-2">
              <span className="spinner-border spinner-border-sm" />
            </div>
          )}

          {loading && (
            <div className="text-center py-4">
              <span className="spinner-border spinner-border-sm" />
            </div>
          )}

          {!loading && error && (
            <div className="text-center text-danger py-3">{t("failedToLoadMessages")}</div>
          )}

          {!loading && !error && messages.length === 0 && (
            <div className="text-center text-muted py-3">{t("noMessagesYet")}</div>
          )}

          {!loading &&
            messages.map((msg, index) => {
              const isProvider = msg.senderId === conversation.providerId;
              const prevMsg = messages[index - 1];
              const showDateSeparator =
                !prevMsg || !isSameDay(prevMsg.createdAt, msg.createdAt);

              return (
                <div key={msg.messageId || index}>
                  {showDateSeparator && (
                    <div className="text-center my-2">
                      <span className="badge bg-light text-dark border">
                        {msg.createdAt ? msg.createdAt.toChatDate(lang) : ""}
                      </span>
                    </div>
                  )}
                  <div
                    className={
                      isProvider
                        ? "chat-message-sent chat-message-grid"
                        : "chat-message-received chat-message-grid"
                    }
                  >
                    <div className="chat-message-sent-avatar">
                      <img src={chat_profile} alt="profile" />
                    </div>
                    <div
                      className={
                        isProvider
                          ? "chat-message-sent-content"
                          : "chat-message-received-content"
                      }
                    >
                      <span className="d-block small text-muted mb-1">
                        {isProvider ? t("provider") : t("Customer")}
                      </span>
                      <MessageContent msg={msg} t={t} />
                      <span>
                        {msg.createdAt ? msg.createdAt.toChatDate(lang, "message") : ""}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default MessagesPanel;
